import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { PaperContent } from 'virtues-bootstrap';
import { map } from 'ramda';

import s from './styles.module.scss';

const PatientInfo = ({ info, name, t, isAvailableUserName, patientId }) => (
  <PaperContent>
    <div className={s.name} data-test="name">
      {isAvailableUserName ? name : patientId}
    </div>
    {map(
      ({ name: infoName, value }) => (
        <div key={value} data-test="id">
          {value && infoName && `${t(infoName)}:`} {value}
        </div>
      ),
      info,
    )}
  </PaperContent>
);

PatientInfo.defaultProps = {
  info: [],
  name: null,
};

PatientInfo.propTypes = {
  info: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string.isRequired,
    }),
  ),
  name: PropTypes.string,
  patientId: PropTypes.string.isRequired,
  isAvailableUserName: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PatientInfo);
